webpackJsonp([28],{

/***/ "+C2d":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('svg',{staticClass:"svg-icon hamburger",class:{'is-active':_vm.isActive},attrs:{"t":"1492500959545","viewBox":"0 0 1024 1024","version":"1.1","xmlns":"http://www.w3.org/2000/svg","p-id":"1691","xmlns:xlink":"http://www.w3.org/1999/xlink","width":"64","height":"64"},on:{"click":_vm.toggleClick}},[_c('path',{attrs:{"d":"M966.8023 568.849776 57.196677 568.849776c-31.397081 0-56.850799-25.452695-56.850799-56.850799l0 0c0-31.397081 25.452695-56.849776 56.850799-56.849776l909.605623 0c31.397081 0 56.849776 25.452695 56.849776 56.849776l0 0C1023.653099 543.397081 998.200404 568.849776 966.8023 568.849776z","p-id":"1692"}}),_vm._v(" "),_c('path',{attrs:{"d":"M966.8023 881.527125 57.196677 881.527125c-31.397081 0-56.850799-25.452695-56.850799-56.849776l0 0c0-31.397081 25.452695-56.849776 56.850799-56.849776l909.605623 0c31.397081 0 56.849776 25.452695 56.849776 56.849776l0 0C1023.653099 856.07443 998.200404 881.527125 966.8023 881.527125z","p-id":"1693"}}),_vm._v(" "),_c('path',{attrs:{"d":"M966.8023 256.17345 57.196677 256.17345c-31.397081 0-56.850799-25.452695-56.850799-56.849776l0 0c0-31.397081 25.452695-56.850799 56.850799-56.850799l909.605623 0c31.397081 0 56.849776 25.452695 56.849776 56.850799l0 0C1023.653099 230.720755 998.200404 256.17345 966.8023 256.17345z","p-id":"1694"}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "/Y4V":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-breadcrumb',{staticClass:"app-breadcrumb",attrs:{"separator":"/"}},[_c('transition-group',{attrs:{"name":"breadcrumb"}},_vm._l((_vm.levelList),function(item,index){return (item.meta.title)?_c('el-breadcrumb-item',{key:item.path},[(item.redirect==='noredirect'||index==_vm.levelList.length-1)?_c('span',{staticClass:"no-redirect"},[_vm._v(_vm._s(item.meta.title))]):_c('router-link',{attrs:{"to":item.redirect||item.path}},[_vm._v(_vm._s(item.meta.title))])],1):_vm._e()}))],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "19nU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router_modules_adminRouter__ = __webpack_require__("v5Xe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router_modules_systemRouter__ = __webpack_require__("SB/p");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__router_modules_operateRouter__ = __webpack_require__("hK9z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_auth__ = __webpack_require__("TIfe");







/**
 * 通过meta.role判断是否与当前用户权限匹配
 * @param roles
 * @param route
 */
function hasPermission(roles, route) {
  if (route.meta && route.meta.role) {
    return roles.some(function (role) {
      return route.meta.role.indexOf(role) >= 0;
    });
  } else {
    return true;
  }
}

/**
 * 递归过滤异步路由表，返回符合用户角色权限的路由表
 * @param asyncRouterMap
 * @param roles
 */
function filterAsyncRouter(asyncRouterMap, roles) {
  // console.log("accessedRouters="+asyncRouterMap);
  var accessedRouters = asyncRouterMap.filter(function (route) {
    if (hasPermission(roles, route)) {
      if (route.children && route.children.length) {
        route.children = filterAsyncRouter(route.children, roles);
      }
      return true;
    }
    return false;
  });
  return accessedRouters;
}

var permission = {
  state: {
    routers: __WEBPACK_IMPORTED_MODULE_1__router__["a" /* constantRouterMap */],
    addRouters: []
  },
  mutations: {
    SET_ROUTERS: function SET_ROUTERS(state, routers) {
      state.addRouters = routers;
      state.routers = __WEBPACK_IMPORTED_MODULE_1__router__["a" /* constantRouterMap */].concat(routers);
    }
  },
  actions: {
    GenerateRoutes: function GenerateRoutes(_ref) {
      var commit = _ref.commit;

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
        // const roles = data
        var accessedRouters = void 0;
        if (Object(__WEBPACK_IMPORTED_MODULE_5__utils_auth__["b" /* getUserName */])().indexOf('root') >= 0) {
          // console.log('admin>=0')
          accessedRouters = __WEBPACK_IMPORTED_MODULE_3__router_modules_systemRouter__["a" /* default */];
        } else if (Object(__WEBPACK_IMPORTED_MODULE_5__utils_auth__["b" /* getUserName */])().indexOf('admin') >= 0) {
          // console.log('admin>=0')
          accessedRouters = __WEBPACK_IMPORTED_MODULE_2__router_modules_adminRouter__["a" /* default */];
        } else if (Object(__WEBPACK_IMPORTED_MODULE_5__utils_auth__["b" /* getUserName */])().indexOf('opreate') >= 0) {
          accessedRouters = __WEBPACK_IMPORTED_MODULE_4__router_modules_operateRouter__["a" /* default */];
        } else {
          accessedRouters = __WEBPACK_IMPORTED_MODULE_4__router_modules_operateRouter__["a" /* default */];
        }
        console.log('accessedRouters', accessedRouters);
        commit('SET_ROUTERS', accessedRouters);
        resolve();
      });
    }
  }
};

/* harmony default export */ __webpack_exports__["a"] = (permission);

/***/ }),

/***/ "2WTH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SidebarItem__ = __webpack_require__("tlvQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_ScrollBar__ = __webpack_require__("gzxC");

//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  components: { SidebarItem: __WEBPACK_IMPORTED_MODULE_2__SidebarItem__["a" /* default */], ScrollBar: __WEBPACK_IMPORTED_MODULE_3__components_ScrollBar__["a" /* default */] },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['sidebar', 'permission_routers']), {
    routes: function routes() {
      //console.log(this.$router.options.routes);
      return this.$router.options.routes;
    },
    isCollapse: function isCollapse() {
      return !this.sidebar.opened;
    }
  })
});

/***/ }),

/***/ "3TAY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  created: function created() {
    this.getBreadcrumb();
  },
  data: function data() {
    return {
      levelList: null
    };
  },

  watch: {
    $route: function $route() {
      this.getBreadcrumb();
    }
  },
  methods: {
    getBreadcrumb: function getBreadcrumb() {
      var matched = this.$route.matched.filter(function (item) {
        return item.name;
      });
      var first = matched[0];
      if (first && first.name !== '首页') {
        matched = [{ path: '/admanage', meta: { title: '首页' } }].concat(matched);
      }
      this.levelList = matched;
    }
  }
});

/***/ }),

/***/ "3eCm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__("Wc9H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__("IaZV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-tree",
  "use": "icon-tree-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-tree\"><defs><style type=\"text/css\"></style></defs><path d=\"M1013.703 693.345c6.865 6.865 10.297 14.874 10.297 24.027l0 205.944c0 9.916-3.432 18.115-10.297 24.599-6.865 6.483-15.255 9.725-25.171 9.725L782.588 957.64c-9.153 0-17.162-3.242-24.027-9.725-6.865-6.483-10.297-14.683-10.297-24.599L748.264 717.372c0-6.102 1.526-11.823 4.577-17.162s7.246-9.534 12.586-12.586 11.06-4.577 17.162-4.577l77.801 0L860.39 546.896c0-4.577-1.144-8.772-3.432-12.586s-5.339-6.865-9.153-9.153-8.009-3.432-12.585-3.432L543.464 521.725l0 161.323 77.801 0c9.153 0 17.162 3.432 24.027 10.297s10.297 14.874 10.297 24.027l0 205.944c0 6.102-1.526 11.823-4.577 17.162s-7.246 9.534-12.585 12.585-11.06 4.577-17.162 4.577L415.321 957.64c-6.102 0-11.823-1.526-17.162-4.577s-9.725-7.246-13.158-12.585-5.149-11.06-5.149-17.162L379.852 717.372c0-9.153 3.432-17.162 10.297-24.027s15.255-10.297 25.171-10.297l76.657 0L491.977 521.725 188.782 521.725c-7.628 0-13.92 2.479-18.878 7.437-4.958 4.958-7.437 10.869-7.437 17.734l0 136.152 77.801 0c9.916 0 18.115 3.432 24.599 10.297s9.725 14.874 9.725 24.027l0 205.944c0 9.916-3.242 18.115-9.725 24.599-6.483 6.483-14.683 9.725-24.599 9.725L34.324 957.64c-3.814 0-7.437-0.572-10.869-1.716-3.432-1.144-6.483-2.67-9.153-4.577-2.67-1.907-5.149-4.386-7.437-7.437-2.288-3.051-4.004-6.293-5.149-9.725C0.572 930.753 0 927.13 0 923.316L0 717.372c0-3.051 0.381-6.102 1.144-9.153s1.907-5.721 3.432-8.009 3.432-4.577 5.721-6.865 4.577-4.195 6.865-5.721 4.958-2.67 8.009-3.432 6.102-1.144 9.153-1.144l77.801 0L112.125 495.41c0-6.865 2.479-12.776 7.437-17.734s10.869-7.437 17.734-7.437l354.682 0L491.978 342.096l-76.657 0c-9.916 0-18.306-3.432-25.171-10.297s-10.297-14.874-10.297-24.027L379.853 101.828c0-9.916 3.432-18.306 10.297-25.171s15.255-10.297 25.171-10.297l205.944 0c6.102 0 11.823 1.716 17.162 5.149 5.339 3.432 9.534 7.818 12.585 13.158 3.051 5.339 4.577 11.06 4.577 17.162l0 205.944c0 9.153-3.432 17.162-10.297 24.027s-14.874 10.297-24.027 10.297l-77.801 0 0 128.143L885.56 470.24c7.628 0 13.92 2.479 18.878 7.437s7.437 10.869 7.437 17.734l0 187.638 76.657 0C998.448 683.048 1006.838 686.48 1013.703 693.345z\" p-id=\"3508\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),

/***/ "4IR2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('scroll-bar',[_c('el-menu',{attrs:{"mode":"vertical","unique-opened":"","default-active":_vm.$route.path,"collapse":_vm.isCollapse,"background-color":"#304156","text-color":"#fff","active-text-color":"#409EFF"}},[_c('sidebar-item',{attrs:{"routes":_vm.permission_routers}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "4wdf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__("Wc9H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__("IaZV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-eye",
  "use": "icon-eye-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-eye\"><defs><style type=\"text/css\"></style></defs><path d=\"M941.677063 391.710356c9.337669-14.005992 6.224772-32.68133-6.224772-43.575447-14.005992-10.894118-32.68133-7.78122-43.575447 6.224771-1.556449 1.556449-174.300768 205.426673-379.727441 205.426673-199.200878 0-379.727441-205.426673-381.28389-206.982098-10.894118-12.450567-31.124881-14.005992-43.575448-3.112898-12.450567 10.894118-14.005992 31.124881-3.112897 43.575448 3.112897 4.668323 40.46255 46.687322 99.600439 93.375667l-79.369676 82.48155c-12.450567 12.450567-10.894118 32.68133 1.556449 43.575448 3.112897 6.224772 10.894118 9.337669 18.675338 9.337669 7.78122 0 15.562441-3.112897 21.787213-9.337669l85.594447-88.706321c40.46255 28.013007 88.706321 54.469566 141.619438 73.14388L340.959485 707.631586c-4.668323 17.118889 4.669346 34.237779 21.787213 38.906101h9.337669c14.005992 0 26.456558-9.337669 29.568432-23.343661l32.68133-110.494556c24.90011 4.668323 51.356668 7.78122 77.813227 7.78122s52.913117-3.112897 77.813227-7.78122l32.68133 108.938108c3.112897 14.005992 17.118889 23.343661 29.569456 23.343661 3.112897 0 6.224772 0 7.78122-1.556449 17.118889-4.669346 26.456558-21.787212 21.788236-38.906102l-32.68133-108.938108c52.913117-18.675338 101.156888-45.131897 141.619438-73.14388l84.037998 87.150896c6.224772 6.224772 14.005992 9.337669 21.787212 9.337669 7.78122 0 15.562441-3.112897 21.787212-9.337669 12.450567-12.450567 12.450567-31.124881 1.556449-43.575448l-79.369675-82.48155c63.808258-46.688345 101.158934-91.820242 101.158934-91.820242z\" p-id=\"7879\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),

/***/ "52mL":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "6gxQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Navbar__ = __webpack_require__("6k2e");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__Navbar__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Sidebar__ = __webpack_require__("WTox");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_1__Sidebar__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__AppMain__ = __webpack_require__("BoPo");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_2__AppMain__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__TagsView__ = __webpack_require__("Vg/Y");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_3__TagsView__["a"]; });





/***/ }),

/***/ "6k2e":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Navbar_vue__ = __webpack_require__("gPq7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6cb9557b_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Navbar_vue__ = __webpack_require__("KiI4");
function injectStyle (ssrContext) {
  __webpack_require__("YLn8")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6cb9557b"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Navbar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6cb9557b_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Navbar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "74lP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('router-view')],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "90Fk":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./example.svg": "OOLB",
	"./eye.svg": "4wdf",
	"./form.svg": "sTIr",
	"./password.svg": "QjmH",
	"./table.svg": "oSYw",
	"./tree.svg": "3eCm",
	"./user.svg": "VdD3"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "90Fk";

/***/ }),

/***/ "AkUR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Layout_vue__ = __webpack_require__("aret");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_60571036_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Layout_vue__ = __webpack_require__("dnyh");
function injectStyle (ssrContext) {
  __webpack_require__("lQ26")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-60571036"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Layout_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_60571036_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Layout_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Ap/k":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "BoPo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AppMain_vue__ = __webpack_require__("Ck6p");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_451ab305_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AppMain_vue__ = __webpack_require__("Zfq1");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AppMain_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_451ab305_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AppMain_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "C3aA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'svg-icon',
  props: {
    iconClass: {
      type: String,
      required: true
    },
    className: {
      type: String
    }
  },
  computed: {
    iconName: function iconName() {
      return '#icon-' + this.iconClass;
    },
    svgClass: function svgClass() {
      if (this.className) {
        return 'svg-icon ' + this.className;
      } else {
        return 'svg-icon';
      }
    }
  }
});

/***/ }),

/***/ "Ck6p":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'AppMain',
  computed: {
    key: function key() {
      var key = this.$route.name;
      for (var k in this.$route.params) {
        key += '/' + k + '=' + this.$route.params[k];
      }
      return key;
      // return this.$router.name !== undefined ? this.$route.name + +new Date() : this.$route + +new Date();
    }
  }
});

/***/ }),

/***/ "EfLN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"scrollContainer",staticClass:"scroll-container",on:{"mousewheel":_vm.handleScroll}},[_c('div',{ref:"scrollWrapper",staticClass:"scroll-wrapper",style:({top: _vm.top + 'px'})},[_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "FaVM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"scrollContainer",staticClass:"scroll-container",on:{"wheel":function($event){$event.preventDefault();_vm.handleScroll($event)}}},[_c('div',{ref:"scrollWrapper",staticClass:"scroll-wrapper",style:({left: _vm.left + 'px'})},[_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "IcnI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modules_app__ = __webpack_require__("WSTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modules_user__ = __webpack_require__("bREw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modules_tagsView__ = __webpack_require__("Zq5Z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modules_permission__ = __webpack_require__("19nU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__getters__ = __webpack_require__("UjVw");








__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

var store = new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  modules: {
    app: __WEBPACK_IMPORTED_MODULE_2__modules_app__["a" /* default */],
    permission: __WEBPACK_IMPORTED_MODULE_5__modules_permission__["a" /* default */],
    user: __WEBPACK_IMPORTED_MODULE_3__modules_user__["a" /* default */],
    tagsView: __WEBPACK_IMPORTED_MODULE_4__modules_tagsView__["a" /* default */]
  },
  getters: __WEBPACK_IMPORTED_MODULE_6__getters__["a" /* default */]
});

/* harmony default export */ __webpack_exports__["a"] = (store);

/***/ }),

/***/ "KiI4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-menu',{staticClass:"navbar",attrs:{"mode":"horizontal"}},[_c('hamburger',{staticClass:"hamburger-container",attrs:{"toggleClick":_vm.toggleSideBar,"isActive":_vm.sidebar.opened}}),_vm._v(" "),_c('breadcrumb'),_vm._v(" "),_c('a',{staticClass:"avatar-container",attrs:{"href":"javascript:;"},on:{"click":_vm.logout}},[_vm._v(" 退出登录 ")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4bccf746_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("74lP");
function injectStyle (ssrContext) {
  __webpack_require__("t8ZV")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4bccf746_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "M9A7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = postLogin;
/* unused harmony export getInfo */
/* unused harmony export logout */
/* harmony export (immutable) */ __webpack_exports__["a"] = getImgCode;
/* unused harmony export GetPermission */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_request__ = __webpack_require__("vLgD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_js_md5__ = __webpack_require__("NC6I");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_js_md5___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_js_md5__);


// 用户登录
function postLogin(username, password, imgValidateCode) {
  var password = __WEBPACK_IMPORTED_MODULE_1_js_md5___default()(password);
  var imgValidateCode = __WEBPACK_IMPORTED_MODULE_1_js_md5___default()(imgValidateCode.toLowerCase());
  return Object(__WEBPACK_IMPORTED_MODULE_0__utils_request__["a" /* default */])({
    url: '/user/login',
    method: 'post',
    // header: imgValidateCode,
    headers: { 'imgValidateCode': imgValidateCode },
    data: {
      username: username,
      password: password
    }
  });
}
// 查询用户信息
function getInfo(token) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__utils_request__["a" /* default */])({
    url: '/author/getUserByToken',
    method: 'get',
    params: {}
  });
}
// 登出
function logout() {
  return Object(__WEBPACK_IMPORTED_MODULE_0__utils_request__["a" /* default */])({
    url: '/user/logout',
    method: 'post'
  });
}
// 验证码
function getImgCode(width, height) {
  var width = width || "";
  var height = height || "";
  return "https://api.surprisedrop.com/" + 'user/getImgValidate?interference_line_num=0&width=' + width + "&height=" + height + "&random=" + Math.random();
}

// 获取权限列表
function GetPermission(token) {
  debugger;
  return Object(__WEBPACK_IMPORTED_MODULE_0__utils_request__["a" /* default */])({
    url: '/author/getMenuTreeList',
    method: 'get',
    params: {}
  });
}

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui__ = __webpack_require__("zL8q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_index_css__ = __webpack_require__("tvR6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__store__ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__icons__ = __webpack_require__("Q7M0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__permission__ = __webpack_require__("kTXO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__filters__ = __webpack_require__("Q0Ca");




// import locale from 'element-ui/lib/locale/lang/cn'



 // icon

 // 权限

//过滤器

__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(__WEBPACK_IMPORTED_MODULE_9__filters__).forEach(function (key) {
  __WEBPACK_IMPORTED_MODULE_1_vue__["default"].filter(key, __WEBPACK_IMPORTED_MODULE_9__filters__[key]);
});

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_element_ui___default.a);

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].config.productionTip = false;

new __WEBPACK_IMPORTED_MODULE_1_vue__["default"]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_5__router__["b" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_4__App__["a" /* default */] }
});

/***/ }),

/***/ "Npla":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"menu-wrapper"},[_vm._l((_vm.routes),function(item){return [(!item.hidden&&item.children&&item.children.length===1)?_c('router-link',{key:item.children[0].name,attrs:{"to":item.path+'/'+item.children[0].path}},[_c('el-menu-item',{staticClass:"submenu-title-noDropdown",attrs:{"index":item.path+'/'+item.children[0].path}},[(item.children[0].meta&&item.children[0].meta.icon)?_c('svg-icon',{attrs:{"icon-class":item.children[0].meta.icon}}):_vm._e(),_vm._v(" "),(item.children[0].meta&&item.children[0].meta.title)?_c('span',[_vm._v(_vm._s(item.children[0].meta.title))]):_vm._e()],1)],1):_vm._e(),_vm._v(" "),(!item.hidden&&item.children&&item.children.length>1)?_c('el-submenu',{key:item.name,attrs:{"index":item.name||item.path}},[_c('template',{slot:"title"},[_c('router-link',{attrs:{"to":item.path}},[(item.meta&&item.meta.icon)?_c('svg-icon',{attrs:{"icon-class":item.meta.icon}}):_vm._e(),_vm._v(" "),(item.meta&&item.meta.title)?_c('span',[_vm._v(_vm._s(item.meta.title))]):_vm._e()],1)],1),_vm._v(" "),_vm._l((item.children),function(child){return (!child.hidden)?[(child.children&&child.children.length>0)?_c('sidebar-item',{key:child.path,staticClass:"nest-menu",attrs:{"routes":[child]}}):_c('router-link',{key:child.name,attrs:{"to":item.path+'/'+child.path}},[_c('el-menu-item',{attrs:{"index":item.path+'/'+child.path}},[(child.meta&&child.meta.icon)?_c('svg-icon',{attrs:{"icon-class":child.meta.icon}}):_vm._e(),_vm._v(" "),(child.meta&&child.meta.title)?_c('span',[_vm._v(_vm._s(child.meta.title))]):_vm._e()],1)],1)]:_vm._e()})],2):_vm._e()]})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "OOLB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__("Wc9H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__("IaZV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-example",
  "use": "icon-example-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-example\"><defs><style type=\"text/css\"></style></defs><path d=\"M770.56 460.8h250.88C998.4 220.16 803.84 25.6 563.2 2.56v250.88c104.96 20.48 186.88 102.4 207.36 207.36z m0 0M460.8 253.44V2.56C220.16 25.6 25.6 220.16 2.56 460.8h250.88c20.48-104.96 102.4-186.88 207.36-207.36z m0 0M563.2 770.56v250.88c243.2-23.04 435.2-217.6 460.8-460.8H773.12C750.08 668.16 668.16 750.08 563.2 770.56z m0 0M253.44 563.2H2.56c23.04 243.2 217.6 435.2 460.8 460.8V773.12C355.84 750.08 273.92 668.16 253.44 563.2z m0 0\" fill=\"\" p-id=\"1816\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),

/***/ "PU/4":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Q0Ca":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "mallItemStatus", function() { return mallItemStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "itemStatus", function() { return itemStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "attrFilter", function() { return attrFilter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "pwdFilter", function() { return pwdFilter; });

var mallItemStatus = function mallItemStatus(val) {
    return val == 0 ? "下架" : "上架";
};

var itemStatus = function itemStatus(val) {
    return val == 1 ? "启用" : "暂停";
};

var attrFilter = function attrFilter(val) {
    var attrObj = ["链接", "卡密", "实物", "兑换码", "话费", "流量"];
    return attrObj[val];
};

var pwdFilter = function pwdFilter(name) {
    var pwd = '';
    switch (name) {
        case 'root':
            pwd = 'root123456';
            break;
        case 'admin':
            pwd = 'admin123456';
            break;
        case 'operate':
            pwd = '123456';
            break;
        default:
            pwd = '';
    }
    return pwd;
};


/***/ }),

/***/ "Q7M0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_SvgIcon__ = __webpack_require__("wp/i");

 // svg组件

// register globally
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('svg-icon', __WEBPACK_IMPORTED_MODULE_1__components_SvgIcon__["a" /* default */]);

var requireAll = function requireAll(requireContext) {
  return requireContext.keys().map(requireContext);
};
var req = __webpack_require__("90Fk");
requireAll(req);

/***/ }),

/***/ "QjmH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__("Wc9H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__("IaZV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-password",
  "use": "icon-password-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-password\"><defs><style type=\"text/css\"></style></defs><path d=\"M780.8 354.579692 665.6 354.579692 665.6 311.689846c0-72.310154-19.849846-193.299692-153.6-193.299692-138.870154 0-153.6 135.049846-153.6 193.299692l0 42.889846L243.2 354.579692 243.2 311.689846C243.2 122.249846 348.790154 0 512 0s268.8 122.249846 268.8 311.689846L780.8 354.579692zM588.8 669.420308C588.8 625.900308 554.220308 590.769231 512 590.769231s-76.8 35.131077-76.8 78.651077c0 29.459692 15.399385 54.468923 38.439385 67.820308l0 89.639385c0 21.740308 17.250462 39.699692 38.4 39.699692s38.4-17.959385 38.4-39.699692l0-89.639385C573.44 723.889231 588.8 698.88 588.8 669.420308zM896 512l0 393.609846c0 65.260308-51.869538 118.390154-115.2 118.390154L243.2 1024c-63.291077 0-115.2-53.129846-115.2-118.390154L128 512c0-65.220923 51.869538-118.390154 115.2-118.390154l537.6 0C844.130462 393.609846 896 446.779077 896 512z\" p-id=\"9230\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),

/***/ "SB/p":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__views_layout_Layout__ = __webpack_require__("AkUR");


var systemRouter = [{
    path: '/',
    component: __WEBPACK_IMPORTED_MODULE_0__views_layout_Layout__["a" /* default */],
    name: 'welcome',
    alwaysShow: false,
    hidden: true,
    meta: {
        role: ['admin'],
        title: '欢迎页',
        icon: 'fa fa-home',
        noCache: true
    },
    children: [{
        path: '/welcome',
        component: function component() {
            return __webpack_require__.e/* import() */(11/* duplicate */).then(__webpack_require__.bind(null, "NjT6"));
        },
        meta: {
            role: ['admin'],
            title: '欢迎页',
            icon: 'fa fa-home',
            noCache: true
        },
        name: 'welcomeIndex',
        hidden: true
    }]
}, {
    path: '/order',
    component: __WEBPACK_IMPORTED_MODULE_0__views_layout_Layout__["a" /* default */],
    redirect: '/order/index',
    name: 'order',
    meta: { role: "admin", title: '订单管理', icon: 'example', noCache: true },
    children: [{
        path: 'orders',
        name: 'orders',
        component: function component() {
            return __webpack_require__.e/* import() */(0/* duplicate */).then(__webpack_require__.bind(null, "e+iX"));
        },
        meta: { role: "admin", title: '订单管理', icon: 'form', noCache: true }
    }]
}, {
    path: '/boxs',
    component: __WEBPACK_IMPORTED_MODULE_0__views_layout_Layout__["a" /* default */],
    redirect: '/boxs/index',
    name: 'boxs',
    meta: { role: "admin", title: '盲盒管理', icon: 'example', noCache: true },
    children: [{
        path: 'index',
        name: 'boxsIndex',
        hidden: false,
        component: function component() {
            return __webpack_require__.e/* import() */(6/* duplicate */).then(__webpack_require__.bind(null, "cNPS"));
        },
        meta: { role: "admin", title: '盲盒列表', icon: 'form', noCache: true }
    }, {
        path: 'edit',
        hidden: true,
        name: 'boxsEdit',
        component: function component() {
            return __webpack_require__.e/* import() */(1/* duplicate */).then(__webpack_require__.bind(null, "c3Y+"));
        },
        meta: { role: "admin", title: '编辑盲盒', icon: 'form', noCache: true }
    }]
}, {
    path: '/products',
    component: __WEBPACK_IMPORTED_MODULE_0__views_layout_Layout__["a" /* default */],
    redirect: '/products/index',
    name: 'products',
    meta: { role: "admin", title: '商品管理', icon: 'form', noCache: true },
    children: [{
        path: 'index',
        name: 'productsIndex',
        hidden: true,
        component: function component() {
            return __webpack_require__.e/* import() */(8/* duplicate */).then(__webpack_require__.bind(null, "9pJy"));
        },
        meta: { role: "admin", title: '商品列表', icon: 'example', noCache: true }
    }, {
        path: 'edit',
        hidden: true,
        name: 'productsEdit',
        component: function component() {
            return __webpack_require__.e/* import() */(2/* duplicate */).then(__webpack_require__.bind(null, "eVTK"));
        },
        meta: { role: "admin", title: '编辑商品', icon: 'form', noCache: true }
    }, {
        path: 'add',
        hidden: true,
        name: 'productsAdd',
        component: function component() {
            return __webpack_require__.e/* import() */(3/* duplicate */).then(__webpack_require__.bind(null, "w5HM"));
        },
        meta: { role: "admin", title: '新增商品', icon: 'form', noCache: true }
    }, {
        path: 'orders',
        name: 'productsOrders',
        hidden: true,
        component: function component() {
            return __webpack_require__.e/* import() */(5/* duplicate */).then(__webpack_require__.bind(null, "Wb7g"));
        },
        meta: { role: "admin", title: '订单管理', icon: 'form', noCache: true }
    }]
}, {
    path: '/user',
    component: __WEBPACK_IMPORTED_MODULE_0__views_layout_Layout__["a" /* default */],
    redirect: '/user/index',
    alwaysShow: true,
    meta: { role: "admin", title: '用户管理', icon: 'example', noCache: true },
    children: [{
        path: 'index',
        name: 'userIndex',
        alwaysShow: true,
        component: function component() {
            return __webpack_require__.e/* import() */(4/* duplicate */).then(__webpack_require__.bind(null, "md3T"));
        },
        meta: { role: "admin", title: '用户管理', icon: 'form', noCache: false }
    }, {
        path: 'changeAmount',
        name: 'changeAmount',
        alwaysShow: true,
        component: function component() {
            return __webpack_require__.e/* import() */(7/* duplicate */).then(__webpack_require__.bind(null, "87pR"));
        },
        meta: { role: "admin", title: '修改余额记录', icon: 'form', noCache: false }
    }]
}, {
    path: '/moneys',
    component: __WEBPACK_IMPORTED_MODULE_0__views_layout_Layout__["a" /* default */],
    redirect: '/moneys/index',
    name: 'moneys',
    meta: { role: "admin", title: '财务管理', icon: 'example', noCache: true },
    children: [{
        path: 'index',
        name: 'moneyIndex',
        component: function component() {
            return __webpack_require__.e/* import() */(14/* duplicate */).then(__webpack_require__.bind(null, "8Q+F"));
        },
        meta: { role: "admin", title: '交易总览', icon: 'example', noCache: true }
    }, {
        path: 'expense',
        name: 'moneyExpense',
        component: function component() {
            return __webpack_require__.e/* import() */(12/* duplicate */).then(__webpack_require__.bind(null, "KVXJ"));
        },
        meta: { role: "admin", title: '消费数据', icon: 'example', noCache: true }
    }, {
        path: 'data',
        name: 'moneyData',
        component: function component() {
            return __webpack_require__.e/* import() */(15/* duplicate */).then(__webpack_require__.bind(null, "0Tml"));
        },
        meta: { role: "admin", title: '收支数据', icon: 'example', noCache: true }
    }, {
        path: 'withdraw',
        name: 'withdraw',
        component: function component() {
            return __webpack_require__.e/* import() */(13/* duplicate */).then(__webpack_require__.bind(null, "4bJV"));
        },
        meta: { role: "admin", title: '提现审核', icon: 'example', noCache: true }
    }]
}, {
    path: '/marketing',
    component: __WEBPACK_IMPORTED_MODULE_0__views_layout_Layout__["a" /* default */],
    redirect: '/marketing/platform',
    name: 'marketing',
    meta: { role: "admin", title: '营销管理', icon: 'example', noCache: true },
    children: [{
        path: 'platform',
        name: 'marketingPlatform',
        component: function component() {
            return __webpack_require__.e/* import() */(10/* duplicate */).then(__webpack_require__.bind(null, "tGOA"));
        },
        meta: { role: "admin", title: '平台数据', icon: 'example', noCache: true }
    }, {
        path: 'user',
        name: 'marketingUser',
        component: function component() {
            return __webpack_require__.e/* import() */(9/* duplicate */).then(__webpack_require__.bind(null, "m5HA"));
        },
        meta: { role: "admin", title: '消费数据', icon: 'example', noCache: true }
    }]
}, {
    path: '/setting',
    component: __WEBPACK_IMPORTED_MODULE_0__views_layout_Layout__["a" /* default */],
    redirect: '/setting/index',
    name: 'setting',
    meta: { role: "admin", title: '配置', icon: 'el-icon-setting', noCache: true },
    children: [{
        path: 'index',
        name: 'settingIndex',
        component: function component() {
            return __webpack_require__.e/* import() */(19).then(__webpack_require__.bind(null, "VlR1"));
        },
        meta: { role: "admin", title: '配置', icon: 'example', noCache: true }
    }]
}];

/* harmony default export */ __webpack_exports__["a"] = (systemRouter);

/***/ }),

/***/ "SM0Y":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'hamburger',
  props: {
    isActive: {
      type: Boolean,
      default: false
    },
    toggleClick: {
      type: Function,
      default: null
    }
  }
});

/***/ }),

/***/ "TIfe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getToken;
/* harmony export (immutable) */ __webpack_exports__["d"] = setToken;
/* harmony export (immutable) */ __webpack_exports__["c"] = removeToken;
/* harmony export (immutable) */ __webpack_exports__["b"] = getUserName;
/* harmony export (immutable) */ __webpack_exports__["e"] = setUserName;
/* unused harmony export GetQueryObject */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_cookie__ = __webpack_require__("lbHh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_js_cookie__);


var TokenKey = 'Admin-Token';
var UserNameKey = 'Admin-UserName';

function getToken() {
  return __WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.get(TokenKey);
}

function setToken(token) {
  return __WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.set(TokenKey, token);
}

function removeToken() {
  return __WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.remove(TokenKey);
}

function getUserName() {
  return __WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.get(UserNameKey);
}

function setUserName(username) {
  return __WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.set(UserNameKey, username);
}

function GetQueryObject(url) {}

/***/ }),

/***/ "UVIz":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "UjVw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var getters = {
  sidebar: function sidebar(state) {
    return state.app.sidebar;
  },
  token: function token(state) {
    return state.user.token;
  },
  visitedViews: function visitedViews(state) {
    return state.tagsView.visitedViews;
  },
  cachedViews: function cachedViews(state) {
    return state.tagsView.cachedViews;
  },
  avatar: function avatar(state) {
    return state.user.avatar;
  },
  name: function name(state) {
    return state.user.name;
  },
  roles: function roles(state) {
    return state.user.roles;
  },
  permission_routers: function permission_routers(state) {
    return state.permission.routers;
  },
  addRouters: function addRouters(state) {
    return state.permission.addRouters;
  }
};
/* harmony default export */ __webpack_exports__["a"] = (getters);

/***/ }),

/***/ "UqIz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("3TAY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6b324838_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("/Y4V");
function injectStyle (ssrContext) {
  __webpack_require__("Ap/k")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6b324838"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6b324838_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "VdD3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__("Wc9H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__("IaZV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-user",
  "use": "icon-user-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-user\"><defs><style type=\"text/css\"></style></defs><path d=\"M504.951 511.98c93.49 0 169.28-74.002 169.28-165.26 0-91.276-75.79-165.248-169.28-165.248-93.486 0-169.287 73.972-169.279 165.248-0.001 91.258 75.793 165.26 169.28 165.26z m77.6 55.098H441.466c-120.767 0-218.678 95.564-218.678 213.45V794.3c0 48.183 97.911 48.229 218.678 48.229H582.55c120.754 0 218.66-1.78 218.66-48.229v-13.77c0-117.887-97.898-213.45-218.66-213.45z\" p-id=\"7987\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),

/***/ "Vg/Y":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TagsView_vue__ = __webpack_require__("X7ex");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e7c79028_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TagsView_vue__ = __webpack_require__("WEPF");
function injectStyle (ssrContext) {
  __webpack_require__("izQA")
  __webpack_require__("jGmu")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-e7c79028"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TagsView_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e7c79028_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TagsView_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "WEPF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('scroll-pane',{ref:"scrollPane",staticClass:"tags-view-container"},_vm._l((Array.from(_vm.visitedViews)),function(tag){return _c('router-link',{key:tag.path,ref:"tag",refInFor:true,staticClass:"tags-view-item",class:_vm.isActive(tag)?'active':'',attrs:{"to":tag.path}},[_vm._v("\n    "+_vm._s(tag.title)+"\n    "),_c('span',{staticClass:"el-icon-close",on:{"click":function($event){_vm.closeViewTags(tag,$event)}}})])}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "WSTi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_cookie__ = __webpack_require__("lbHh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_js_cookie__);


var app = {
  state: {
    sidebar: {
      opened: !+__WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.get('sidebarStatus')
    }
  },
  mutations: {
    TOGGLE_SIDEBAR: function TOGGLE_SIDEBAR(state) {
      if (state.sidebar.opened) {
        __WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.set('sidebarStatus', 1);
      } else {
        __WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.set('sidebarStatus', 0);
      }
      state.sidebar.opened = !state.sidebar.opened;
    }
  },
  actions: {
    ToggleSideBar: function ToggleSideBar(_ref) {
      var commit = _ref.commit;

      commit('TOGGLE_SIDEBAR');
    }
  }
};

/* harmony default export */ __webpack_exports__["a"] = (app);

/***/ }),

/***/ "WTox":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("2WTH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e158c8a8_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("4IR2");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e158c8a8_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "X7ex":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_ScrollPane__ = __webpack_require__("sUix");

//
//
//
//
//
//
//
//
//


// import { generateTitle } from '@/utils/i18n'

/* harmony default export */ __webpack_exports__["a"] = ({
  components: { ScrollPane: __WEBPACK_IMPORTED_MODULE_1__components_ScrollPane__["a" /* default */] },
  computed: {
    visitedViews: function visitedViews() {
      return this.$store.state.tagsView.visitedViews;
    }
  },
  mounted: function mounted() {
    this.addViewTags();
  },

  methods: {
    // generateTitle,
    closeViewTags: function closeViewTags(view, $event) {
      var _this = this;

      this.$store.dispatch('delVisitedViews', view).then(function (views) {
        if (_this.isActive(view)) {
          var latestView = views.slice(-1)[0];
          if (latestView) {
            _this.$router.push(latestView.path);
          } else {
            _this.$router.push('/');
          }
        }
      });
      $event.preventDefault();
    },
    generateRoute: function generateRoute() {
      if (this.$route.name) {
        return this.$route;
      }
      return false;
    },
    addViewTags: function addViewTags() {
      var route = this.generateRoute();
      if (!route) {
        return false;
      }
      this.$store.dispatch('addVisitedViews', route);
    },
    isActive: function isActive(route) {
      return route.path === this.$route.path;
    },
    moveToCurrentTag: function moveToCurrentTag() {
      var _this2 = this;

      var tags = this.$refs.tag;
      this.$nextTick(function () {
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(tags), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var tag = _step.value;

            if (tag.to === _this2.$route.path) {
              _this2.$refs.scrollPane.moveToTarget(tag.$el);
              break;
            }
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }
      });
    }
  },
  watch: {
    $route: function $route() {
      this.addViewTags();
      this.moveToCurrentTag();
    }
  }
});

/***/ }),

/***/ "XOMi":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "YLn8":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return constantRouterMap; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_layout_Layout__ = __webpack_require__("AkUR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router_modules_systemRouter__ = __webpack_require__("SB/p");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__router_modules_fuliRouter__ = __webpack_require__("nAZO");


// const _import = require('./_import_' + process.env.NODE_ENV)
// in development-env not use lazy-loading, because lazy-loading too many pages will cause webpack hot update too slow. so only in production use lazy-loading;
// detail: https://panjiachen.github.io/vue-element-admin-site/#/lazy-loading

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* Layout */



/**
* hidden: true                   if `hidden:true` will not show in the sidebar(default is false)
* redirect: noredirect           if `redirect:noredirect` will no redirct in the breadcrumb
* name:'router-name'             the name is used by <keep-alive> (must set!!!)
* meta : {
    title: 'title'               the name show in submenu and breadcrumb (recommend set)
    icon: 'svg-name'             the icon show in the sidebar,
  }
**/
var constantRouterMap = [{ path: '/login', name: "login", component: function component() {
        return __webpack_require__.e/* import() */(26).then(__webpack_require__.bind(null, "T+/8"));
    }, hidden: true }, { path: '/404', component: function component() {
        return __webpack_require__.e/* import() */(24).then(__webpack_require__.bind(null, "+H76"));
    }, hidden: true }, { path: '/', redirect: '/welcome', hidden: true
    // ...systemRouter,
    // ...fuliRouter,
    // { path: '*', redirect: '/404', hidden: true }
}];

/* harmony default export */ __webpack_exports__["b"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
    // mode: 'history', //后端支持可开
    scrollBehavior: function scrollBehavior() {
        return { y: 0 };
    },
    routes: constantRouterMap
}));

/***/ }),

/***/ "Z451":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//

var padding = 15; // tag's padding

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'scrollPane',
  data: function data() {
    return {
      left: 0
    };
  },

  methods: {
    handleScroll: function handleScroll(e) {
      var eventDelta = e.wheelDelta || -e.deltaY * 3;
      var $container = this.$refs.scrollContainer;
      var $containerWidth = $container.offsetWidth;
      var $wrapper = this.$refs.scrollWrapper;
      var $wrapperWidth = $wrapper.offsetWidth;

      if (eventDelta > 0) {
        this.left = Math.min(0, this.left + eventDelta);
      } else {
        if ($containerWidth - padding < $wrapperWidth) {
          if (this.left < -($wrapperWidth - $containerWidth + padding)) {
            this.left = this.left;
          } else {
            this.left = Math.max(this.left + eventDelta, $containerWidth - $wrapperWidth - padding);
          }
        } else {
          this.left = 0;
        }
      }
    },
    moveToTarget: function moveToTarget($target) {
      var $container = this.$refs.scrollContainer;
      var $containerWidth = $container.offsetWidth;
      var $targetLeft = $target.offsetLeft;
      var $targetWidth = $target.offsetWidth;

      if ($targetLeft < -this.left) {
        // tag in the left
        this.left = -$targetLeft + padding;
      } else if ($targetLeft + padding > -this.left && $targetLeft + $targetWidth < -this.left + $containerWidth - padding) {
        // tag in the current view
        // eslint-disable-line
      } else {
        // tag in the right
        this.left = -($targetLeft - ($containerWidth - $targetWidth) + padding);
      }
    }
  }
});

/***/ }),

/***/ "Zfq1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"app-main"},[_c('keep-alive',[(!_vm.$route.meta.noCache)?_c('router-view',{key:_vm.key}):_vm._e()],1),_vm._v(" "),(_vm.$route.meta.noCache)?_c('router-view',{key:_vm.key}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Zq5Z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray__ = __webpack_require__("d7EF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray__);




var tagsView = {
  state: {
    visitedViews: [],
    cachedViews: []
  },
  mutations: {
    ADD_VISITED_VIEWS: function ADD_VISITED_VIEWS(state, view) {
      if (state.visitedViews.some(function (v) {
        return v.path === view.path;
      })) return;
      state.visitedViews.push({
        name: view.name,
        path: view.path,
        title: view.meta.title || 'no-name'
      });
      if (!view.meta.noCache) {
        state.cachedViews.push(view.name);
      }
    },
    DEL_VISITED_VIEWS: function DEL_VISITED_VIEWS(state, view) {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(state.visitedViews.entries()), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var _ref = _step.value;

          var _ref2 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray___default()(_ref, 2);

          var i = _ref2[0];
          var v = _ref2[1];

          if (v.path === view.path) {
            state.visitedViews.splice(i, 1);
            break;
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(state.cachedViews), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var _i = _step2.value;

          if (_i === view.name) {
            var index = state.cachedViews.indexOf(_i);
            state.cachedViews.splice(index, 1);
            break;
          }
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }
    }
  },
  actions: {
    addVisitedViews: function addVisitedViews(_ref3, view) {
      var commit = _ref3.commit;

      commit('ADD_VISITED_VIEWS', view);
    },
    delVisitedViews: function delVisitedViews(_ref4, view) {
      var commit = _ref4.commit,
          state = _ref4.state;

      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve) {
        commit('DEL_VISITED_VIEWS', view);
        resolve([].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(state.visitedViews)));
      });
    }
  }
};

/* harmony default export */ __webpack_exports__["a"] = (tagsView);

/***/ }),

/***/ "aret":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__views_layout_components__ = __webpack_require__("6gxQ");
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'layout',
  components: {
    Navbar: __WEBPACK_IMPORTED_MODULE_0__views_layout_components__["b" /* Navbar */],
    Sidebar: __WEBPACK_IMPORTED_MODULE_0__views_layout_components__["c" /* Sidebar */],
    AppMain: __WEBPACK_IMPORTED_MODULE_0__views_layout_components__["a" /* AppMain */],
    TagsView: __WEBPACK_IMPORTED_MODULE_0__views_layout_components__["d" /* TagsView */]
  },
  computed: {
    sidebar: function sidebar() {
      return this.$store.state.app.sidebar;
    }
  }
});

/***/ }),

/***/ "bREw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_login__ = __webpack_require__("M9A7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_auth__ = __webpack_require__("TIfe");




var user = {
  state: {
    token: Object(__WEBPACK_IMPORTED_MODULE_2__utils_auth__["a" /* getToken */])(),
    name: '',
    avatar: '',
    roles: ''
  },

  mutations: {
    SET_TOKEN: function SET_TOKEN(state, token) {
      state.token = token;
    },
    SET_NAME: function SET_NAME(state, name) {
      state.name = name;
    },
    SET_AVATAR: function SET_AVATAR(state, avatar) {
      state.avatar = avatar;
    },
    SET_ROLES: function SET_ROLES(state, roles) {
      state.roles = roles;
    }
  },

  actions: {
    // 登录
    Login: function Login(_ref, userInfo) {
      var commit = _ref.commit;

      var username = userInfo.username.trim();

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        Object(__WEBPACK_IMPORTED_MODULE_1__api_login__["b" /* postLogin */])(username, userInfo.password, userInfo.smscode).then(function (response) {
          var data = response.returnValue;
          Object(__WEBPACK_IMPORTED_MODULE_2__utils_auth__["d" /* setToken */])({ token: data.token, userId: data.id });
          commit('SET_TOKEN', data.token);
          resolve();
        }).catch(function (error) {
          reject(error);
        });
      });
    },


    // 获取用户信息
    GetInfo: function GetInfo(_ref2) {
      var commit = _ref2.commit,
          state = _ref2.state;


      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        commit('SET_ROLES', 'data.roleName');
        resolve();
        // getInfo(state.token).then(response => {
        //   const data = response.returnValue
        //   commit('SET_ROLES', data.roleName)
        //   resolve(response)
        // }).catch(error => {
        //   reject(error)
        // })
      });
    },


    // 登出
    LogOut: function LogOut(_ref3) {
      var commit = _ref3.commit,
          state = _ref3.state;

      commit('SET_TOKEN', '');
      commit('SET_ROLES', '');
      Object(__WEBPACK_IMPORTED_MODULE_2__utils_auth__["c" /* removeToken */])();
      // return new Promise((resolve, reject) => {
      //   logout(state.token).then(() => {
      //     commit('SET_TOKEN', '')
      //     commit('SET_ROLES', [])
      //     removeToken()
      //     resolve()
      //   }).catch(error => {
      //     reject(error)
      //   })
      // })
    },


    // 前端 登出
    FedLogOut: function FedLogOut(_ref4) {
      var commit = _ref4.commit;

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
        commit('SET_TOKEN', '');
        Object(__WEBPACK_IMPORTED_MODULE_2__utils_auth__["c" /* removeToken */])();
        resolve();
      });
    }
  }
};

/* harmony default export */ __webpack_exports__["a"] = (user);

/***/ }),

/***/ "dahE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("SM0Y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ffa11a30_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("+C2d");
function injectStyle (ssrContext) {
  __webpack_require__("52mL")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-ffa11a30"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ffa11a30_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "dnyh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-wrapper",class:{hideSidebar:!_vm.sidebar.opened}},[_c('sidebar',{staticClass:"sidebar-container"}),_vm._v(" "),_c('div',{staticClass:"main-container"},[_c('navbar'),_vm._v(" "),_c('tags-view'),_vm._v(" "),_c('app-main')],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "gPq7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Breadcrumb__ = __webpack_require__("UqIz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Hamburger__ = __webpack_require__("dahE");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Breadcrumb: __WEBPACK_IMPORTED_MODULE_2__components_Breadcrumb__["a" /* default */],
    Hamburger: __WEBPACK_IMPORTED_MODULE_3__components_Hamburger__["a" /* default */]
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['sidebar', 'avatar'])),
  methods: {
    toggleSideBar: function toggleSideBar() {
      this.$store.dispatch('ToggleSideBar');
    },
    logout: function logout() {
      this.$store.dispatch('LogOut').then(function () {
        location.reload(); // 为了重新实例化vue-router对象 避免bug
      });
    }
  }
});

/***/ }),

/***/ "gzxC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("yeib");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_182ee85c_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("EfLN");
function injectStyle (ssrContext) {
  __webpack_require__("PU/4")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-182ee85c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_182ee85c_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "hK9z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__views_layout_Layout__ = __webpack_require__("AkUR");


var systemRouter = [{
    path: '/',
    component: __WEBPACK_IMPORTED_MODULE_0__views_layout_Layout__["a" /* default */],
    name: 'welcome',
    alwaysShow: false,
    hidden: true,
    meta: {
        role: ['admin', 'operate'],
        title: '欢迎页',
        icon: 'fa fa-home',
        noCache: true
    },
    children: [{
        path: '/welcome',
        component: function component() {
            return __webpack_require__.e/* import() */(11/* duplicate */).then(__webpack_require__.bind(null, "NjT6"));
        },
        meta: {
            role: ['admin', 'operate'],
            title: '欢迎页',
            icon: 'fa fa-home',
            noCache: true
        },
        name: 'welcomeIndex',
        hidden: true
    }]
}, {
    path: '/order',
    component: __WEBPACK_IMPORTED_MODULE_0__views_layout_Layout__["a" /* default */],
    redirect: '/order/index',
    name: 'order',
    meta: { role: "admin", title: '订单管理', icon: 'example', noCache: true },
    children: [{
        path: 'orders',
        name: 'orders',
        component: function component() {
            return __webpack_require__.e/* import() */(0/* duplicate */).then(__webpack_require__.bind(null, "e+iX"));
        },
        meta: { role: "admin", title: '订单管理', icon: 'form', noCache: true }
    }]
}, {
    path: '/boxs',
    component: __WEBPACK_IMPORTED_MODULE_0__views_layout_Layout__["a" /* default */],
    redirect: '/boxs/index',
    name: 'boxs',
    meta: { role: "admin", title: '盲盒管理', icon: 'example', noCache: true },
    children: [{
        path: 'index',
        name: 'boxsIndex',
        hidden: false,
        component: function component() {
            return __webpack_require__.e/* import() */(6/* duplicate */).then(__webpack_require__.bind(null, "cNPS"));
        },
        meta: { role: "admin", title: '盲盒列表', icon: 'form', noCache: true }
    }, {
        path: 'edit',
        hidden: true,
        name: 'boxsEdit',
        component: function component() {
            return __webpack_require__.e/* import() */(1/* duplicate */).then(__webpack_require__.bind(null, "c3Y+"));
        },
        meta: { role: "admin", title: '编辑盲盒', icon: 'form', noCache: true }
    }]
}, {
    path: '/products',
    component: __WEBPACK_IMPORTED_MODULE_0__views_layout_Layout__["a" /* default */],
    redirect: '/products/index',
    name: 'products',
    meta: { role: "admin", title: '商品管理', icon: 'form', noCache: true },
    children: [{
        path: 'index',
        name: 'productsIndex',
        hidden: true,
        component: function component() {
            return __webpack_require__.e/* import() */(8/* duplicate */).then(__webpack_require__.bind(null, "9pJy"));
        },
        meta: { role: "admin", title: '商品列表', icon: 'example', noCache: true }
    }, {
        path: 'edit',
        hidden: true,
        name: 'productsEdit',
        component: function component() {
            return __webpack_require__.e/* import() */(2/* duplicate */).then(__webpack_require__.bind(null, "eVTK"));
        },
        meta: { role: "admin", title: '编辑商品', icon: 'form', noCache: true }
    }, {
        path: 'add',
        hidden: true,
        name: 'productsAdd',
        component: function component() {
            return __webpack_require__.e/* import() */(3/* duplicate */).then(__webpack_require__.bind(null, "w5HM"));
        },
        meta: { role: "admin", title: '新增商品', icon: 'form', noCache: true }
    }, {
        path: 'orders',
        name: 'productsOrders',
        hidden: true,
        component: function component() {
            return __webpack_require__.e/* import() */(5/* duplicate */).then(__webpack_require__.bind(null, "Wb7g"));
        },
        meta: { role: "admin", title: '订单管理', icon: 'form', noCache: true }
    }]
}, {
    path: '/user',
    component: __WEBPACK_IMPORTED_MODULE_0__views_layout_Layout__["a" /* default */],
    redirect: '/user/index',
    alwaysShow: true,
    meta: { role: "admin", title: '用户管理', icon: 'example', noCache: true },
    children: [{
        path: 'index',
        name: 'userIndex',
        alwaysShow: true,
        component: function component() {
            return __webpack_require__.e/* import() */(4/* duplicate */).then(__webpack_require__.bind(null, "md3T"));
        },
        meta: { role: "admin", title: '用户管理', icon: 'form', noCache: false }
    }, {
        path: 'changeAmount',
        name: 'changeAmount',
        alwaysShow: true,
        component: function component() {
            return __webpack_require__.e/* import() */(7/* duplicate */).then(__webpack_require__.bind(null, "87pR"));
        },
        meta: { role: "admin", title: '修改余额记录', icon: 'form', noCache: false }
    }]
},
//     {
//     path: '/moneys',
//     component: Layout,
//     redirect: '/moneys/index',
//     name: 'moneys',
//     meta: { role: "admin", title: '财务管理', icon: 'example', noCache: true },
//     children: [{
//         path: 'index',
//         name: 'moneyIndex',
//         component: () => import('@/views/moneys/index'),
//         meta: { role: "admin",title: '交易总览', icon: 'example', noCache: true }
//     },
//         {
//             path: 'expense',
//             name: 'moneyExpense',
//             component: () => import('@/views/moneys/expense'),
//             meta: { role: "admin",title: '消费数据', icon: 'example', noCache: true }
//         },
//         {
//             path: 'data',
//             name: 'moneyData',
//             component: () => import('@/views/moneys/data'),
//             meta: { role: "admin",title: '收支数据', icon: 'example', noCache: true }
//         },
//         {
//             path: 'withdraw',
//             name: 'withdraw',
//             component: () => import('@/views/moneys/withdraw'),
//             meta: { role: "admin",title: '提现审核', icon: 'example', noCache: true }
//         }]
// },
{
    path: '/marketing',
    component: __WEBPACK_IMPORTED_MODULE_0__views_layout_Layout__["a" /* default */],
    redirect: '/marketing/platform',
    name: 'marketing',
    meta: { role: "admin", title: '营销管理', icon: 'example', noCache: true },
    children: [{
        path: 'platform',
        name: 'marketingPlatform',
        component: function component() {
            return __webpack_require__.e/* import() */(10/* duplicate */).then(__webpack_require__.bind(null, "tGOA"));
        },
        meta: { role: "admin", title: '平台数据', icon: 'example', noCache: true }
    }, {
        path: 'user',
        name: 'marketingUser',
        component: function component() {
            return __webpack_require__.e/* import() */(9/* duplicate */).then(__webpack_require__.bind(null, "m5HA"));
        },
        meta: { role: "admin", title: '消费数据', icon: 'example', noCache: true }
    }]
}];

/* harmony default export */ __webpack_exports__["a"] = (systemRouter);

/***/ }),

/***/ "izQA":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "jGmu":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "kTXO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store__ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_nprogress__ = __webpack_require__("Y81h");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_nprogress___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_nprogress__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_nprogress_nprogress_css__ = __webpack_require__("UVIz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_nprogress_nprogress_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_nprogress_nprogress_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui__ = __webpack_require__("zL8q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_auth__ = __webpack_require__("TIfe");



 // Progress 进度条
 // Progress 进度条样式

 // 验权

var whiteList = ['/login']; // 不重定向白名单
__WEBPACK_IMPORTED_MODULE_1__router__["b" /* default */].beforeEach(function (to, from, next) {
  __WEBPACK_IMPORTED_MODULE_3_nprogress___default.a.start();
  if (Object(__WEBPACK_IMPORTED_MODULE_6__utils_auth__["a" /* getToken */])()) {
    if (to.path === '/login') {
      next({ path: '/' });
      __WEBPACK_IMPORTED_MODULE_3_nprogress___default.a.done(); // router在hash模式下 手动改变hash 重定向回来 不会触发afterEach 暂时hack方案 ps：history模式下无问题，可删除该行！
    } else {
      if (__WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getters.roles.length === 0) {
        // 判断当前用户是否已拉取完user_info信息
        __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].dispatch('GetInfo').then(function (response) {
          // 拉取user_info
          // const data = response.result
          __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].dispatch('GenerateRoutes').then(function () {
            // 生成可访问的路由表
            console.log('p', __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getters.addRouters);
            __WEBPACK_IMPORTED_MODULE_1__router__["b" /* default */].addRoutes(__WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getters.addRouters); // 动态添加可访问路由表
            next(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, to, { replace: true })); // hack方法 确保addRoutes已完成 ,replace: true so the navigation will not leave a history record
          }).catch(function (err) {
            console.log('err', err);
            __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].dispatch('FedLogOut').then(function () {
              __WEBPACK_IMPORTED_MODULE_5_element_ui__["Message"].error(err || 'Verification failed, please login again');
              next({ path: '/' });
            });
          });
        });
      } else {
        next();
      }

      // next()
      // let tempToken = JSON.parse(getToken()).token;

      // store.dispatch('CheckToken', tempToken).then(res => { // 拉取user_info
      //   next()
      // }).catch(() => {
      //   store.dispatch('FedLogOut').then(() => {
      //     Message.error('验证失败,请重新登录0')
      //     next({ path: '/login' })
      //   })
      // })
    }
  } else {
    if (whiteList.indexOf(to.path) !== -1) {
      next();
    } else {
      next('/login');
      __WEBPACK_IMPORTED_MODULE_3_nprogress___default.a.done();
    }
  }
});

__WEBPACK_IMPORTED_MODULE_1__router__["b" /* default */].afterEach(function () {
  __WEBPACK_IMPORTED_MODULE_3_nprogress___default.a.done(); // 结束Progress
});

/***/ }),

/***/ "l1x3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'SidebarItem',
  props: {
    routes: {
      type: Array
    }
  },

  created: function created() {
    // console.log("routers>>>>:"+this.routes);
  }
});

/***/ }),

/***/ "lQ26":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "nAZO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__views_layout_Layout__ = __webpack_require__("AkUR");


var fuliRouter = [{
    path: '/fuli',
    component: __WEBPACK_IMPORTED_MODULE_0__views_layout_Layout__["a" /* default */],
    redirect: '/fuli/index',
    alwaysShow: true,
    meta: { role: "admin", title: '福利社管理', icon: 'example', noCache: true },
    children: [{
        path: 'index',
        name: 'fuli',
        alwaysShow: true,
        component: function component() {
            return __webpack_require__.e/* import() */(17).then(__webpack_require__.bind(null, "0jCB"));
        },
        meta: { role: "admin", title: '商品管理', icon: 'form', noCache: true }
    }, {
        path: 'edit/id/:id',
        name: 'fuliEdit',
        hidden: true,
        component: function component() {
            return __webpack_require__.e/* import() */(20).then(__webpack_require__.bind(null, "RrOu"));
        },
        meta: { role: "admin", title: '编辑商品', icon: 'form', noCache: false }
    }, {
        path: 'manage',
        name: 'welfareManage',
        alwaysShow: true,
        component: function component() {
            return __webpack_require__.e/* import() */(25).then(__webpack_require__.bind(null, "ekF4"));
        },
        meta: { role: "admin", title: '资源位类型', icon: 'form', noCache: true }
    }, {
        path: 'resources',
        name: 'welfareResources',
        alwaysShow: true,
        component: function component() {
            return __webpack_require__.e/* import() */(22).then(__webpack_require__.bind(null, "VKxc"));
        },
        meta: { role: "admin", title: '资源位管理', icon: 'form', noCache: true }
    }, {
        path: 'manageEdit',
        name: 'welfareManageEdit',
        alwaysShow: true,
        hidden: true,
        component: function component() {
            return __webpack_require__.e/* import() */(23).then(__webpack_require__.bind(null, "qJcT"));
        },
        meta: { role: "admin", title: '新增/编辑', icon: 'form', noCache: true }
    }, {
        path: 'edit',
        name: 'welfareEdit',
        alwaysShow: true,
        hidden: true,
        component: function component() {
            return __webpack_require__.e/* import() */(21).then(__webpack_require__.bind(null, "nN8y"));
        },
        meta: { role: "admin", title: '新增/编辑资源位', icon: 'form', noCache: true }
    }, {
        path: 'order',
        name: 'order',
        alwaysShow: true,
        component: function component() {
            return __webpack_require__.e/* import() */(0/* duplicate */).then(__webpack_require__.bind(null, "e+iX"));
        },
        meta: { role: "admin", title: '订单管理', icon: 'form', noCache: false }
    }, {
        path: 'statistics',
        name: 'statistics',
        alwaysShow: true,
        component: function component() {
            return __webpack_require__.e/* import() */(16).then(__webpack_require__.bind(null, "meih"));
        },
        meta: { role: "admin", title: '数据报表', icon: 'form', noCache: false }
    }, {
        path: 'classifyManageM',
        name: 'productsClassifyManageM',
        hidden: true,
        component: function component() {
            return __webpack_require__.e/* import() */(18).then(__webpack_require__.bind(null, "+uc9"));
        },
        meta: { role: "admin", title: '商品分类管理', icon: 'example', noCache: true }
    }]
}];

/* unused harmony default export */ var _unused_webpack_default_export = (fuliRouter);

/***/ }),

/***/ "oSYw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__("Wc9H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__("IaZV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-table",
  "use": "icon-table-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-table\"><defs><style type=\"text/css\"></style></defs><path d=\"M568.6 0h454.9v454.9H568.6V0z m0 568.6h454.9v454.9H568.6V568.6zM0 568.6h454.9v454.9H0V568.6zM0 0h454.9v454.9H0V0z\" fill=\"\" p-id=\"5071\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),

/***/ "p95K":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "sTIr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__("Wc9H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__("IaZV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-form",
  "use": "icon-form-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-form\"><defs><style type=\"text/css\"></style></defs><path d=\"M942.827259 80.3367c-11.42419-11.406794-26.41051-17.117866-41.377386-17.117866-14.985296 0-29.952172 5.711072-41.358967 17.117866L719.392444 221.014696l-19.441794 19.441794L681.577187 258.832 569.516971 370.909611 375.99749 564.411697l0 0.019443 0 84.372619 81.145112 0 0.010233 0 95.418186-95.435583 213.398228-213.400275 3.14155-3.14155-0.019443 0 9.979282-9.977235 0 0L942.827259 163.073052C965.697129 140.259464 965.697129 103.186104 942.827259 80.3367z\" p-id=\"3231\" /><path d=\"M793.542234 367.521444 580.14196 580.939115 484.72582 676.376745 473.299583 687.800935 457.152834 687.800935 375.99749 687.800935 337.000314 687.800935 337.000314 648.803759 337.000314 564.411697 337.000314 548.264948 348.424504 536.838711 541.943986 343.338672 654.004201 231.259014 665.428392 219.834824 64.020082 219.834824 64.020082 960.781166 804.966425 960.781166 804.966425 356.116697 796.607036 364.475062Z\" p-id=\"3232\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),

/***/ "sUix":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("Z451");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_32b5c0a3_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("FaVM");
function injectStyle (ssrContext) {
  __webpack_require__("p95K")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-32b5c0a3"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_32b5c0a3_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "t8ZV":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "tlvQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarItem_vue__ = __webpack_require__("l1x3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7a436fda_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarItem_vue__ = __webpack_require__("Npla");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarItem_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7a436fda_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarItem_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "tvR6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "v5Xe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__views_layout_Layout__ = __webpack_require__("AkUR");


var systemRouter = [{
    path: '/',
    component: __WEBPACK_IMPORTED_MODULE_0__views_layout_Layout__["a" /* default */],
    name: 'welcome',
    alwaysShow: false,
    hidden: true,
    meta: {
        role: ['admin', 'operate'],
        title: '欢迎页',
        icon: 'fa fa-home',
        noCache: true
    },
    children: [{
        path: '/welcome',
        component: function component() {
            return __webpack_require__.e/* import() */(11/* duplicate */).then(__webpack_require__.bind(null, "NjT6"));
        },
        meta: {
            role: ['admin', 'operate'],
            title: '欢迎页',
            icon: 'fa fa-home',
            noCache: true
        },
        name: 'welcomeIndex',
        hidden: true
    }]
}, {
    path: '/order',
    component: __WEBPACK_IMPORTED_MODULE_0__views_layout_Layout__["a" /* default */],
    redirect: '/order/index',
    name: 'order',
    meta: { role: "admin", title: '订单管理', icon: 'example', noCache: true },
    children: [{
        path: 'orders',
        name: 'orders',
        component: function component() {
            return __webpack_require__.e/* import() */(0/* duplicate */).then(__webpack_require__.bind(null, "e+iX"));
        },
        meta: { role: "admin", title: '订单管理', icon: 'form', noCache: true }
    }]
}, {
    path: '/boxs',
    component: __WEBPACK_IMPORTED_MODULE_0__views_layout_Layout__["a" /* default */],
    redirect: '/boxs/index',
    name: 'boxs',
    meta: { role: "admin", title: '盲盒管理', icon: 'example', noCache: true },
    children: [{
        path: 'index',
        name: 'boxsIndex',
        hidden: false,
        component: function component() {
            return __webpack_require__.e/* import() */(6/* duplicate */).then(__webpack_require__.bind(null, "cNPS"));
        },
        meta: { role: "admin", title: '盲盒列表', icon: 'form', noCache: true }
    }, {
        path: 'edit',
        hidden: true,
        name: 'boxsEdit',
        component: function component() {
            return __webpack_require__.e/* import() */(1/* duplicate */).then(__webpack_require__.bind(null, "c3Y+"));
        },
        meta: { role: "admin", title: '编辑盲盒', icon: 'form', noCache: true }
    }]
}, {
    path: '/products',
    component: __WEBPACK_IMPORTED_MODULE_0__views_layout_Layout__["a" /* default */],
    redirect: '/products/index',
    name: 'products',
    meta: { role: "admin", title: '商品管理', icon: 'form', noCache: true },
    children: [{
        path: 'index',
        name: 'productsIndex',
        hidden: true,
        component: function component() {
            return __webpack_require__.e/* import() */(8/* duplicate */).then(__webpack_require__.bind(null, "9pJy"));
        },
        meta: { role: "admin", title: '商品列表', icon: 'example', noCache: true }
    }, {
        path: 'edit',
        hidden: true,
        name: 'productsEdit',
        component: function component() {
            return __webpack_require__.e/* import() */(2/* duplicate */).then(__webpack_require__.bind(null, "eVTK"));
        },
        meta: { role: "admin", title: '编辑商品', icon: 'form', noCache: true }
    }, {
        path: 'add',
        hidden: true,
        name: 'productsAdd',
        component: function component() {
            return __webpack_require__.e/* import() */(3/* duplicate */).then(__webpack_require__.bind(null, "w5HM"));
        },
        meta: { role: "admin", title: '新增商品', icon: 'form', noCache: true }
    }, {
        path: 'orders',
        name: 'productsOrders',
        hidden: true,
        component: function component() {
            return __webpack_require__.e/* import() */(5/* duplicate */).then(__webpack_require__.bind(null, "Wb7g"));
        },
        meta: { role: "admin", title: '订单管理', icon: 'form', noCache: true }
    }]
}, {
    path: '/user',
    component: __WEBPACK_IMPORTED_MODULE_0__views_layout_Layout__["a" /* default */],
    redirect: '/user/index',
    alwaysShow: true,
    meta: { role: "admin", title: '用户管理', icon: 'example', noCache: true },
    children: [{
        path: 'index',
        name: 'userIndex',
        alwaysShow: true,
        component: function component() {
            return __webpack_require__.e/* import() */(4/* duplicate */).then(__webpack_require__.bind(null, "md3T"));
        },
        meta: { role: "admin", title: '用户管理', icon: 'form', noCache: false }
    }, {
        path: 'changeAmount',
        name: 'changeAmount',
        alwaysShow: true,
        component: function component() {
            return __webpack_require__.e/* import() */(7/* duplicate */).then(__webpack_require__.bind(null, "87pR"));
        },
        meta: { role: "admin", title: '修改余额记录', icon: 'form', noCache: false }
    }]
}, {
    path: '/moneys',
    component: __WEBPACK_IMPORTED_MODULE_0__views_layout_Layout__["a" /* default */],
    redirect: '/moneys/index',
    name: 'moneys',
    meta: { role: "admin", title: '财务管理', icon: 'example', noCache: true },
    children: [{
        path: 'index',
        name: 'moneyIndex',
        component: function component() {
            return __webpack_require__.e/* import() */(14/* duplicate */).then(__webpack_require__.bind(null, "8Q+F"));
        },
        meta: { role: "admin", title: '交易总览', icon: 'example', noCache: true }
    }, {
        path: 'expense',
        name: 'moneyExpense',
        component: function component() {
            return __webpack_require__.e/* import() */(12/* duplicate */).then(__webpack_require__.bind(null, "KVXJ"));
        },
        meta: { role: "admin", title: '消费数据', icon: 'example', noCache: true }
    }, {
        path: 'data',
        name: 'moneyData',
        component: function component() {
            return __webpack_require__.e/* import() */(15/* duplicate */).then(__webpack_require__.bind(null, "0Tml"));
        },
        meta: { role: "admin", title: '收支数据', icon: 'example', noCache: true }
    }, {
        path: 'withdraw',
        name: 'withdraw',
        component: function component() {
            return __webpack_require__.e/* import() */(13/* duplicate */).then(__webpack_require__.bind(null, "4bJV"));
        },
        meta: { role: "admin", title: '提现审核', icon: 'example', noCache: true }
    }]
}, {
    path: '/marketing',
    component: __WEBPACK_IMPORTED_MODULE_0__views_layout_Layout__["a" /* default */],
    redirect: '/marketing/platform',
    name: 'marketing',
    meta: { role: "admin", title: '营销管理', icon: 'example', noCache: true },
    children: [{
        path: 'platform',
        name: 'marketingPlatform',
        component: function component() {
            return __webpack_require__.e/* import() */(10/* duplicate */).then(__webpack_require__.bind(null, "tGOA"));
        },
        meta: { role: "admin", title: '平台数据', icon: 'example', noCache: true }
    }, {
        path: 'user',
        name: 'marketingUser',
        component: function component() {
            return __webpack_require__.e/* import() */(9/* duplicate */).then(__webpack_require__.bind(null, "m5HA"));
        },
        meta: { role: "admin", title: '消费数据', icon: 'example', noCache: true }
    }]
}];

/* harmony default export */ __webpack_exports__["a"] = (systemRouter);

/***/ }),

/***/ "vLgD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui__ = __webpack_require__("zL8q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store__ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_auth__ = __webpack_require__("TIfe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_qs__ = __webpack_require__("mw3O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_qs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_qs__);








/*
* 调用request方法
* 调用方式:
* 引入API: import { Xxx } from '@/api/xxx';
* 方式一：
* Xxx(params).then(res => {
*   console.log(res)
* });
*
* 方式二(ES7异步变同步)：
* async XXX(){
*   const res =  await Xxx(params);
*   console.log(res)
*   Next...
* }
* */

// 创建axios实例
var service = __WEBPACK_IMPORTED_MODULE_2_axios___default.a.create({
  // withCredentials: true,
  baseURL: "https://api.surprisedrop.com/", // api的base_url
  timeout: 15000 // 请求超时时间
});

var cookieInfo = {};
// request拦截器

service.interceptors.request.use(function (config) {
  //非简单请求
  // config.headers['Content-Type'] = 'application/x-www-form-urlencoded'
  // debugger;
  if (Object(__WEBPACK_IMPORTED_MODULE_5__utils_auth__["a" /* getToken */])()) {
    cookieInfo = JSON.parse(Object(__WEBPACK_IMPORTED_MODULE_5__utils_auth__["a" /* getToken */])());
  }
  // console.log( cookieInfo.userId);
  if (__WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].getters.token) {
    config.headers['token'] = cookieInfo.token; // 让每个请求携带自定义token 请根据实际情况自行修改
  }
  // debugger;
  if (config.method === "post" || config.method === "put") {

    // config.data.loginUserId = cookieInfo.userId
    config.data = __WEBPACK_IMPORTED_MODULE_6_qs___default.a.stringify(config.data);
    // config.data = {
    //     ...config.data,
    //     userId: cookieInfo.userId
    // }
  } else {
    // config.params.userId = cookieInfo.userId
    config.params = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({
      loginUserId: cookieInfo.userId
    }, config.params);
  }
  return config;
}, function (error) {
  // Do something with request error
  console.log(error); // for debug
  __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
});
// respone拦截器
service.interceptors.response.use(function (response) {
  /*
  * code为非20000是抛错 可结合自己业务进行修改
  */
  var res = response.data;
  if (res.code !== 200) {
    Object(__WEBPACK_IMPORTED_MODULE_3_element_ui__["Message"])({
      message: res.errorMsg,
      type: 'error',
      duration: 5 * 1000
    });

    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(res.errorMsg ? res.errorMsg : 'error');
  } else {
    return response.data;
  }
}, function (error) {
  // console.log('err' + error)// for debug
  Object(__WEBPACK_IMPORTED_MODULE_3_element_ui__["Message"])({
    message: error.message,
    type: 'error',
    duration: 5 * 1000
  });
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
});

/* harmony default export */ __webpack_exports__["a"] = (service);

/***/ }),

/***/ "wp/i":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("C3aA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_20996423_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("yVgN");
function injectStyle (ssrContext) {
  __webpack_require__("XOMi")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-20996423"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_20996423_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app'
});

/***/ }),

/***/ "yVgN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{class:_vm.svgClass,attrs:{"aria-hidden":"true"}},[_c('use',{attrs:{"xlink:href":_vm.iconName}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "yeib":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//

var delta = 15;
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'scrollBar',
  data: function data() {
    return {
      top: 0
    };
  },

  methods: {
    handleScroll: function handleScroll(e) {
      e.preventDefault();
      var $container = this.$refs.scrollContainer;
      var $containerHeight = $container.offsetHeight;
      var $wrapper = this.$refs.scrollWrapper;
      var $wrapperHeight = $wrapper.offsetHeight;
      if (e.wheelDelta > 0) {
        this.top = Math.min(0, this.top + e.wheelDelta);
      } else {
        if ($containerHeight - delta < $wrapperHeight) {
          if (this.top < -($wrapperHeight - $containerHeight + delta)) {
            this.top = this.top;
          } else {
            this.top = Math.max(this.top + e.wheelDelta, $containerHeight - $wrapperHeight - delta);
          }
        } else {
          this.top = 0;
        }
      }
    }
  }
});

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.6f68dfb09ae6d8897f69.js